import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class SupportService {
  createNewTicket(supportRequest) {
    return axios.post(API_URL + '/feedback', supportRequest)
  }
  getCurentUserFeedbackList(shopId) {
    return axios.get(API_URL + '/feedback/current-user-tickets?shopId=' + shopId)
  }
  getFeedbackbyId(Id){
    return axios.get(API_URL + '/feedback/' + Id)
  }
}

export default new SupportService()
